import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  FileButton,
  Flex,
  Grid,
  GridCol,
  Input,
  Menu,
  Select,
  Text,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import {
  useDebouncedCallback,
  useDisclosure,
  useHotkeys,
  useIsFirstRender,
  useMediaQuery,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBrandBootstrap,
  IconCaretDown,
  IconDownload,
  IconEdit,
  IconEye,
  IconFileDownload,
  IconFileExport,
  IconFileTypography,
  IconFileUpload,
  IconPlus,
  IconSearch,
  IconStatusChange,
  IconTimeDuration15,
  IconTrash,
  IconUserCode,
} from "@tabler/icons-react";
import { addHours } from "date-fns";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import * as xlsx from "xlsx";
import {
  keySearchWarehouseInWardList,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { SaveKeySearch } from "../../../common/SaveKeySearch/SaveKeySearch";
import { _localization } from "../../../config/location";
import { cobalt_blue, green, teal } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblInwardGetList } from "../../../model/TblOutWard";
import {
  getBranchSelect,
  getTblDmEmployeeSelect,
  getTblInventoryTransactionTypeInWard,
} from "../../../service/getSelectApi";
import DeleteView from "./components/DeleteModal";
import { dataStatusOption } from "./constants";
import useDynamicHeight from "./hooks/useDynamicHeight";
import { inward } from "./services";
import moment from "moment";
import { IconBarcode } from "@tabler/icons-react";

function getColorStatus(text: any) {
  switch (text) {
    case "OPEN":
      return cobalt_blue.base;
    case "LOCK":
      return green.light;
    default:
      return cobalt_blue.base;
  }
}

function getStatus(text: any) {
  switch (text) {
    case "OPEN":
      return "Đang nhập";
    case "LOCK":
      return "Phiếu khoá";
    default:
      return "Tạo mới";
  }
}

const WarehouseInWard = () => {
  const navigate = useNavigate();
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblInwardGetList[]>([]);
  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [file, setFile] = useState<File | null>(null);

  const [dataInventoryTransactionType, setDataInventoryTransactionType] =
    useState<ComboboxItem[]>([]);
  const [dataEmployee, setDataEmployee] = useState<ComboboxItem[]>([]);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width: 900px)");
  const [columnPinning, setColumnPinning] = useState<boolean | undefined>(true);
  const firstRender = useIsFirstRender();
  const _searchJson = localStorage.getItem(keySearchWarehouseInWardList)
    ? JSON.parse(localStorage.getItem(keySearchWarehouseInWardList) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const height = useDynamicHeight(headerRef, 150);

  const [dataItemCode, setDataItemCode] = useState<any[]>([]);
  const lastSearchRef = useRef(""); //dùng để lưu từ khóa tìm kiếm tránh call lặp lại

  const innitStateSearch = useMemo(
    () => ({
      KeySearch:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.KeySearch as string)
          : "",
      FromTransationDate:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.FromTransationDate
          ? new Date(_searchJson.FromTransationDate)
          : new Date(
              new Date(
                new Date(
                  new Date().setDate(new Date().getDate() - 14),
                ).setHours(0, 0, 0, 0),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      ToTransationDate:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.ToTransationDate
          ? new Date(_searchJson.ToTransationDate)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      SourceTypeCode:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.SourceTypeCode as string)
          : "",
      branchId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.branchId as string)
          : String(
              JSON.parse(localStorage.getItem("userLoginHeader") || "{}")
                ?.branchId || "",
            ),
      Status:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Status as string)
          : "",
      EmpId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.EmpId as string)
          : "",
      ItemCode:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.ItemCode
          : "",
    }),
    [firstRender, _searchJson],
  );

  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });
  const sizeGrid = { base: 6, sm: 6, md: 4, lg: 4, xl: 2 };

  // Giữ lại option mã sản phẩm đang lọc để hiển thị đúng trên ô chọn,
  // kể cả khi giá trị được lấy lại từ localStorage (chưa có trong dataItemCode)
  const [selectedItemCode, setSelectedItemCode] = useState<ComboboxItem | null>(
    innitStateSearch.ItemCode
      ? {
          value: String(innitStateSearch.ItemCode),
          label: String(innitStateSearch.ItemCode),
        }
      : null,
  );

  const dataItemCodeSelect = useMemo(() => {
    if (
      selectedItemCode &&
      !dataItemCode.some((item) => item?.value === selectedItemCode.value)
    ) {
      return [selectedItemCode, ...dataItemCode];
    }
    return dataItemCode;
  }, [dataItemCode, selectedItemCode]);

  const columns = React.useMemo<MRT_ColumnDef<TblInwardGetList>[]>(
    () => [
      {
        accessorKey: "transactionCode",
        header: "Mã phiếu",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={async () => {
                actionInward(
                  row.original.transactionId,
                  row.original.sourceType,
                  true,
                  row.original.sourceCode,
                  "detail",
                );
              }}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 150,
        Cell: ({ row }) => (
          <>
            <Badge color={getColorStatus(row.original.status)}>
              {getStatus(row.original.status)}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "transactionDate",
        header: "Ngày giao dịch",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "createDate",
        header: "Ngày lập",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "createName",
        header: "Người lập",
        size: 200,
        // Cell: ({ row }) => (
        //   <>
        //     <AvatarUtils value={row.original.createName ?? ""} />
        //   </>
        // ),
      },
      {
        accessorKey: "sourceCode",
        header: "Mã chứng từ gốc",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={700} size="sm">
            {renderedCellValue}
          </Text>
        ),
      },
      {
        accessorKey: "sourceTypeName",
        header: "Loại chứng từ gốc",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              variant="filled"
              color={getColorType(row.original.sourceType)}
            >
              {renderedCellValue}
            </Badge>
          </>
        ),
        size: 255,
      },
      {
        accessorKey: "branchName",
        header: "Chi nhánh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "invName",
        header: "Kho",
        Cell: ({ row }) => <>{row.original.invName}</>,
      },
      {
        accessorKey: "returnReason",
        header: "Lý do đổi trả",
      },
      {
        accessorKey: "description",
        header: "Ghi chú",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label={renderedCellValue}>
            <p>{renderedCellValue}</p>
          </Tooltip>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableResizing: false,
        size: 130,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip
              label={row.original.status === "LOCK" ? "Đã sửa" : "Chỉnh sửa"}
            >
              <ActionIcon
                variant="light"
                aria-label="Settings"
                disabled={row.original.status === "LOCK"}
                color={"orange"}
                onClick={async () => {
                  actionInward(
                    row.original.transactionId,
                    row.original.sourceType,
                    row.original.status === "LOCK",
                    row.original.sourceCode,
                    "edit",
                  );
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xem chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={async () => {
                  actionInward(
                    row.original.transactionId,
                    row.original.sourceType,
                    true,
                    row.original.sourceCode,
                    "detail",
                  );
                }}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                disabled={row.original.status === "LOCK"}
                onClick={async () => {
                  deleteData(
                    row.original.transactionId,
                    row.original.sourceType ?? "",
                  );
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [dataInventoryTransactionType, dataBranch],
  );

  const handleExport = () => {
    try {
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");
      xlsx.writeFile(workbook, "danh-sach-phieu-xuat-kho.xlsx");
      toast.success("Export excel thành công", { autoClose: 1500 });
    } catch (error) {
      toast.error("Export excel thất bại", { autoClose: 1500 });
    }
  };

  const createData = () => {
    navigate("/warehouse-config/create-warehouse-in-ward");
  };

  const actionInward = (
    id: string | number,
    type: string | number | null,
    isLocked: boolean,
    sourceCode: string | null,
    action: string,
  ) => {
    // if (type === "NHAP_HANG_NCC") {
    //   navigate(`/warehouse-config/supplier-request-form`, {
    //     state: {
    //       id: id,
    //       sourceType: type,
    //       isLocked: isLocked,
    //       sourceCode: sourceCode,
    //     },
    //   });
    // } else
    navigate(`/warehouse-config/${action}-warehouse-in-ward`, {
      state: {
        id: id,
        sourceType: type,
        isLocked: isLocked,
        sourceCode: sourceCode,
      },
    });
  };

  const getColorType = (type: string | null) => {
    switch (type) {
      case "NHAP_DIEU_CHUYEN_CHI_NHANH":
        return "#f06418";
      case "NHAP_DIEU_CHUYEN_CHI_NHANH_SERIAL":
        return "#ffab09";
      case "NHAP_HUY":
        return "#d9d02f";
      case "NHAP_DIEU_CHINH":
        return "#6bd731";
      case "NHAP_DIEU_CHUYEN_NOI_BO":
        return "#09b8ff";
      case "NHAP_DIEU_CHUYEN_NOI_BO_SERIAL":
        return "#1f32c4";
      case "NHAP_TRA_NCC":
        return "#2bdd66";
      case "NHAP_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT":
        return "orange";
      case "NHAP_THAO_DO":
        return "#087f5b";
      case "NHAP_HANG_DOI_TRA":
        return "#d9480f";
      case "NHAP_THANH_PHAM_SAN_XUAT":
        return "#22b8cf";
      case "NHAP_BAN":
        return teal.light;
      case null:
        return "rgba(0, 0, 0, 0)";
      case "NOI_BO":
        return "#656a7e";
    }
  };

  const deleteData = (id: string | number, sourceType: string) => {
    try {
      modals.openConfirmModal({
        title: (
          <>
            <Title order={5}>Xóa phiếu nhập kho!</Title>
          </>
        ),

        size: "550px",
        children: (
          <DeleteView
            idItem={id}
            onClose={setDeleteViewStatus}
            sourceType={sourceType}
          />
        ),
        confirmProps: { display: "none" },
        cancelProps: { display: "none" },
      });
    } catch (error) {
      console.error(error);
      return;
    }
  };

  useHotkeys([
    [
      "F11",
      () => {
        createData();
      },
    ],
  ]);

  const fetchData = async () => {
    setIsLoading(true);
    // setIsRefetching(true);
    // setIsError(false);

    // let _softing = "";
    // let isOrder = false;
    // if (sorting && sorting.length > 0) {
    //   let _q = sorting[0];
    //   if (_q) {
    //     _softing = _q.id;
    //     isOrder = _q.desc;
    //   }
    // }
    let queryParams = {
      Skip:
        firstRender && _searchJson
          ? _searchJson.Skip
          : pagination.pageIndex * pagination.pageSize,
      Take: firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
    } as any;

    try {
      const search = form.getValues();

      queryParams = {
        ...queryParams,
        Skip: pagination?.pageIndex * pagination?.pageSize,
        Take: pagination?.pageSize,
        KeySearch: search?.KeySearch ? search?.KeySearch.trim().toString() : "",
        branchId: search?.branchId ? search?.branchId.toString() : "",
        FromTransationDate: search?.FromTransationDate
          ? moment(search?.FromTransationDate).format(
              "YYYY-MM-DDT00:00:00.000[Z]",
            )
          : "",
        ToTransationDate: search?.ToTransationDate
          ? moment(search?.ToTransationDate).format(
              "YYYY-MM-DDT00:00:00.000[Z]",
            )
          : "",
        SourceTypeCode: search?.SourceTypeCode
          ? search?.SourceTypeCode.toString()
          : "",
        Status: search?.Status ? search?.Status.toString() : "",
        EmpId: search?.EmpId ? search?.EmpId.toString() : "",
        // sort: _softing,
        // isOrder: isOrder,
        Type: 1,
        ItemCode: search?.ItemCode || "",
      };

      const urlParams = new URLSearchParams(queryParams as any);
      if (sorting?.length > 0) {
        const { id, desc } = sorting[0];
        urlParams.append("sort", id);
        urlParams.append("isOrder", String(desc));
      }

      const response = await inward.getListInward(queryParams);
      if (response && response.success) {
        let result = response.data;
        setIsLoading(false);
        setData(result || []);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      } else setData([]);
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      localStorage.setItem(
        keySearchWarehouseInWardList,
        JSON.stringify(queryParams),
      );
    }
  };

  const fetchdataInventoryTransactionType = async () => {
    const response = await getTblInventoryTransactionTypeInWard();

    setDataInventoryTransactionType(
      response.map((type) => ({ value: type.value, label: type.text })),
    );
  };

  const fetchDataEmployee = async () => {
    const response = await getTblDmEmployeeSelect();
    setDataEmployee(
      response.map((employee) => ({
        value: employee.value,
        label: employee.att1 + " - " + employee.text,
      })),
    );
  };

  const uploadFile = async (e: File) => {
    if (!e) {
      NotificationExtension.Fails("File rỗng hoặc chưa chọn file !");
      return;
    }
    open();
    // await new Promise((resolve) => setTimeout(resolve, 2000));
    const formData = new FormData();
    formData.append("FormFile", e);

    var resSaveFile = await repositoryPos.post<MessageResponse<boolean>>(
      "/api/v1//TblInventorySerialOnHand/import-child-serial",
      formData,
    );
    if (resSaveFile?.success) {
      alert("Import file thành công!");
      setFile(null);
      await fetchData();
    } else alert("Import file thất bại !");
    setFile(null);
    close();
  };
  const fetchDataBranch = async () => {
    const getDataBranch = await getBranchSelect();

    const mappedData = getDataBranch
      .filter(
        (item) =>
          item.value != null && item.text != null && item.value !== "-1",
      )
      .map((item) => ({
        value: item.value,
        label: `${item.att2 + " - " + item.text}`,
      }));
    setDataBranch(mappedData);
  };

  // Lấy dữ liệu mã sản phẩm
  const DataItemCode = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      const response = await repositoryPos.get(
        `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`,
      );
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((i: any) => i.value && i.text)
          .map((branch: any) => ({
            value: branch.value,
            label: branch.text,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataItemCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  // Sử dụng debounce để trì hoãn việc gọi API
  const debouncedDataItemCode = useDebouncedCallback((value: string) => {
    const trimmedValue = value.trim();
    if (trimmedValue.length >= 3 && trimmedValue !== lastSearchRef.current) {
      lastSearchRef.current = trimmedValue; // Ghi nhớ từ khóa
      DataItemCode(trimmedValue); // Gọi API với từ khóa tìm kiếm
    }
  }, 500);

  useEffect(() => {
    fetchData();
  }, [sorting, deleteViewStatus, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    if (file) {
      if (
        file &&
        (file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          file.type === "application/vnd.ms-excel")
      )
        uploadFile(file);
      else NotificationExtension.Fails("File không đúng định đạng Excel !");
    }
  }, [file]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,

    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.transactionId?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "transactionCode", "status"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      sorting,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "lg",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: columnPinning,
    mantineTableProps: {
      striped: false,
    },
  });

  // Lưu key search
  // useEffect(() => {
  //   if (checkedPinSearch) {
  //     const runAsyncFunctions = async () => {
  //       await SaveKeySearch(form, null, 1);

  //       // localStorage.removeItem("allValueKeySearch");
  //     };
  //     const nextuse = async () => {
  //       await Promise.all([fetchDataBranch(), fetchDataEmployee()]);
  //       await runAsyncFunctions();
  //       await fetchData();
  //     };
  //     nextuse();
  //   }
  // }, [checkedPinSearch]);

  useEffect(() => {
    fetchdataInventoryTransactionType();
    fetchDataBranch();
    fetchDataEmployee();
    // Lấy lại danh sách mã sản phẩm theo giá trị đang lọc để hiển thị đúng tên sản phẩm
    if (selectedItemCode?.value) {
      lastSearchRef.current = selectedItemCode.value;
      DataItemCode(selectedItemCode.value);
    }
  }, []);

  // Cập nhật lại label của mã sản phẩm đang lọc khi lấy được dữ liệu từ API
  useEffect(() => {
    if (!selectedItemCode) return;
    const option = dataItemCode.find(
      (item) => item?.value === selectedItemCode.value,
    );
    if (option && option.label !== selectedItemCode.label) {
      setSelectedItemCode(option);
    }
  }, [dataItemCode, selectedItemCode]);

  useEffect(() => {
    if (isSmallScreen) {
      setColumnPinning(false); // Bỏ ghim cột khi thu nhỏ màn hình
    } else {
      setColumnPinning(true);
    }
  }, [isSmallScreen]);

  return (
    <form>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex
          gap={0}
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          <Flex gap="md" align="center" direction="row" wrap="wrap">
            <Button
              leftSection={<IconDownload size={14} />}
              color="blue"
              variant="outline"
              component="a"
              href="/template/mau_import_serial_con.xlsx"
              download
            >
              File mẫu import
            </Button>
            <FileButton onChange={setFile}>
              {(props) => (
                <Button
                  leftSection={
                    <IconFileDownload
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  {...props}
                >
                  Import Serial Con
                </Button>
              )}
            </FileButton>
            <Button
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                createData();
              }}
            >
              Tạo mới
            </Button>

            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  rightSection={
                    <IconCaretDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Chức năng
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconFileExport
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={handleExport}
                >
                  Export Excel
                </Menu.Item>
                <Tooltip label={"Chức năng đang update"}>
                  <Menu.Item
                    leftSection={
                      <IconFileUpload
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  ></Menu.Item>
                </Tooltip>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Flex>

        <Grid mt={"10px"}>
          <GridCol span={sizeGrid}>
            <Input
              w={"100%"}
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={form.key("KeySearch")}
              // onKeyDown={async (e) => {
              //   if (e.key === "Enter") {
              //     await fetchData();
              //     localStorage.setItem(
              //       "allValueKeySearch",
              //       JSON.stringify({
              //         ...form.getValues(),
              //         url: String(window.location.pathname),
              //       })
              //     );
              //   }
              // }}
              {...form.getInputProps("KeySearch")}
            />
          </GridCol>
          <GridCol span={sizeGrid}>
            <DatePickerInput
              type="default"
              key={form.key("FromTransationDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              {...form.getInputProps("FromTransationDate")}
            />
          </GridCol>
          <GridCol span={sizeGrid}>
            <DatePickerInput
              type="default"
              key={form.key("ToTransationDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              {...form.getInputProps("ToTransationDate")}
            />
          </GridCol>
          <GridCol span={sizeGrid}>
            <Select
              placeholder={"Trạng thái"}
              searchable
              clearable
              data={dataStatusOption}
              leftSection={<IconStatusChange color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              key={form.key("status")}
              nothingFoundMessage={"Loading..."}
              {...form.getInputProps("Status")}
            />
          </GridCol>

          <GridCol span={sizeGrid}>
            <Select
              key={
                dataInventoryTransactionType.length ||
                form.key("SourceTypeCode")
              }
              placeholder={"Loại chứng từ gốc"}
              searchable
              clearable
              leftSection={<IconFileTypography color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={dataInventoryTransactionType}
              nothingFoundMessage={"Loading..."}
              // onClick={() => {
              //   if (dataInventoryTransactionType.length === 0) {
              //     fetchdataInventoryTransactionType();
              //   }
              // }}
              {...form.getInputProps("SourceTypeCode")}
            />
          </GridCol>
          <GridCol span={sizeGrid}>
            <Select
              searchable
              clearable
              placeholder="Chọn chi nhánh"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              nothingFoundMessage={"Loading..."}
              data={dataBranch}
              // onClick={() => {
              //   if (dataBranch.length === 0) {
              //     fetchDataBranch();
              //   }
              // }}
              key={dataBranch.length || form.key("branchId")}
              {...form.getInputProps("branchId")}
            />
          </GridCol>
          <GridCol span={sizeGrid}>
            <Select
              placeholder={"Chọn nhân viên"}
              searchable
              clearable
              data={dataEmployee}
              leftSection={<IconUserCode color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              nothingFoundMessage={"Loading..."}
              key={dataEmployee.length || form.key("EmpId")}
              // onClick={() => {
              //   if (dataEmployee.length === 0) {
              //     fetchDataEmployee();
              //   }
              // }}
              {...form.getInputProps("EmpId")}
            />
          </GridCol>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Nhập mã sản phẩm"
              clearable
              searchable
              data={dataItemCodeSelect}
              value={selectedItemCode?.value ?? null}
              onChange={(v, option) => {
                setSelectedItemCode(
                  v ? (option ?? { value: v, label: v }) : null,
                );
                form.setFieldValue("ItemCode", v ?? "");
              }}
              onSearchChange={(value) => {
                debouncedDataItemCode(value); // Sử dụng debounce
              }}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
            />
          </Grid.Col>
          <GridCol span={{ base: 4, sm: 4, md: 1.5, lg: 1 }}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
                // localStorage.setItem(
                //   "allValueKeySearch",
                //   JSON.stringify({
                //     ...form.getValues(),
                //     url: String(window.location.pathname),
                //   })
                // );
              }}
            >
              Tìm kiếm
            </Button>
          </GridCol>
        </Grid>
      </div>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </form>
  );
};

export default WarehouseInWard;
